import React from 'react';
import '../less/index.less'
import DOMPurify from 'utils/sanitize';
import { ReactSVG } from 'react-svg';
import { getSafeLinkProps } from '../../../../helpers/utils/urlSecurity';

const getVariant = (items) => {
  if (!items || items.length === 0) return "text";

  const first = items[0] || {};

  if (first.img) return "with-image";
  if (first.benefits && first.benefits.length) return "with-benefits";

  return "only-text";
};

export default function template() {
  const { title, titleTag = "h1", itemTitleTag = "h2", items = [], page } = this.props;

  const variant = getVariant(items);

  const ItemTitleTag = itemTitleTag;
  const TitleTag = titleTag;

  return (
    <div className={`product-list-new product-list-new_${variant}`}>
      <div className="container">
        {title && <TitleTag className="product-list-new__title">{this.l10n(title)}</TitleTag>}
        <div className="product-list-new__list">
          <div className="product-list-new__items">
            {items.map(card => (
              <a
                key={card.id}
                className={`product-list-new__item item-product-list-new item-product-list-new_${variant}`}
                {...getSafeLinkProps(card.link, {navigate: this.navigate})}
                id={`${page} ${card.id}-details`}
              >
                {card.img && (
                  <ReactSVG
                    src={card.img} 
                    className="item-product-list-new__image" 
                    beforeInjection={(svg) => {
                      if (!svg.getAttribute('viewBox')) {
                        const width = svg.getAttribute('width');
                        const height = svg.getAttribute('height');

                        if (width && height) {
                          svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
                        }
                      }
                    }}
                  />
                )}
                <div className="item-product-list-new__left">
                  <ItemTitleTag
                    className="item-product-list-new__title"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(this.l10n(card.title))
                    }}
                  />
                  <div
                    className="item-product-list-new__text"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(this.l10n(card.text))
                    }}
                  />
                  <span className="item-product-list-new__btn">{this.l10n("TRANSFERS_NEW_ITEM_BTN")}</span>
                </div>
                {card.benefits && (
                  <div className="item-product-list-new__benefits">
                    {card.benefits.map((benefit, idx) => (
                      <div key={idx} className="item-product-list-new__benefit benefit-item-product-list-new">
                        <div className="benefit-item-product-list-new__title">
                          {this.l10n(benefit.title)}
                        </div>
                        <div className="benefit-item-product-list-new__text">
                          {this.l10n(benefit.text)}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
